import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import {
  CueHistory,
  CueHistoryActivityReview,
  CueHistoryReviewFilter,
  CueTagSeverity,
  CueUserWarning,
} from 'src/app/models/fincas/cue.model';
import { CueStatusPresenter } from '../../presenters/cue-status.presenter';
import { CueExportAuditFacade } from '../../services/cue-export-audit.facade';

/** Renders a readable CUE history while keeping raw support data collapsed. */
@Component({
  selector: 'app-cue-history',
  templateUrl: './cue-history.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CueHistoryComponent {
  @Input({ required: true })
  public cueHistory: CueHistory[] = [];

  @Input()
  public reviewFilter: CueHistoryReviewFilter = 'all';

  public constructor(private readonly auditFacade: CueExportAuditFacade) {}

  public acceptedCount(item: CueHistory): number {
    return this.auditFacade.acceptedCount(item);
  }

  public acceptedReviews(item: CueHistory): CueHistoryActivityReview[] {
    return this.auditFacade.activityReviews(item, 'accepted');
  }

  public actionableIssues(item: CueHistory): CueUserWarning[] {
    return this.auditFacade.actionableIssues(item);
  }

  public hasAcceptedReviews(item: CueHistory): boolean {
    return this.acceptedReviews(item).length > 0;
  }

  public hasErrors(item: CueHistory): boolean {
    return this.actionableIssues(item).length > 0;
  }

  public historySummary(item: CueHistory): string {
    return this.auditFacade.historySummary(item);
  }

  public pendingCount(item: CueHistory): number {
    return this.auditFacade.pendingCount(item);
  }

  public rejectedCount(item: CueHistory): number {
    return this.auditFacade.rejectedCount(item);
  }

  public shouldShowAcceptedBlock(item: CueHistory): boolean {
    return this.hasAcceptedReviews(item) && this.reviewFilter !== 'problems';
  }

  public shouldShowProblemBlock(item: CueHistory): boolean {
    return this.hasErrors(item) && this.reviewFilter !== 'accepted';
  }

  public statusLabel(item: CueHistory): string {
    return CueStatusPresenter.statusLabel(item.estado);
  }

  public statusSeverity(item: CueHistory): CueTagSeverity {
    return CueStatusPresenter.statusSeverity(item.estado);
  }

  public technicalDetails(item: CueHistory): string {
    return this.auditFacade.technicalDetails(item);
  }
}
